'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'sun';
var width = 576;
var height = 512;
var aliases = [9728];
var unicode = 'f185';
var svgPathData = 'M288-32c5.6 0 10.8 3 13.7 7.8l60.5 101 114.2-28.6c5.4-1.4 11.2 .2 15.2 4.2s5.6 9.8 4.2 15.2l-28.6 114.2 101 60.5c4.8 2.9 7.8 8.1 7.8 13.7s-3 10.8-7.8 13.7l-101 60.5 28.6 114.2c1.4 5.5-.2 11.2-4.2 15.2s-9.8 5.6-15.2 4.2l-114.2-28.6-60.5 101c-2.9 4.8-8.1 7.8-13.7 7.8s-10.8-3-13.7-7.8l-60.5-101-114.2 28.6c-5.5 1.4-11.2-.2-15.2-4.2s-5.6-9.8-4.2-15.2l28.6-114.2-101-60.5C3 266.8 0 261.6 0 256s3-10.8 7.8-13.7l101-60.5-28.6-114.2c-1.4-5.5 .2-11.2 4.2-15.2s9.8-5.5 15.2-4.2l114.2 28.6 60.5-101 1.2-1.7c3-3.8 7.6-6.1 12.5-6.1zM235.1 103.4c-3.6 6-10.8 9-17.6 7.3l-99.8-25 25 99.8c1.7 6.8-1.2 14-7.3 17.6L47.1 256 135.4 308.9c6 3.6 9 10.8 7.3 17.6l-25 99.8 99.8-25 2.6-.4c6-.5 11.9 2.4 15 7.7l52.9 88.3 52.9-88.3 1.5-2.1c3.9-4.6 10.1-6.7 16.1-5.2l99.8 25-25-99.8c-1.7-6.8 1.2-14 7.3-17.6l88.3-52.9-88.3-52.9c-6-3.6-9-10.8-7.3-17.6l25-99.8-99.8 25c-6.8 1.7-14-1.2-17.6-7.3L288 15.1 235.1 103.4zM288 368a112 112 0 1 1 0-224 112 112 0 1 1 0 224zm0-192a80 80 0 1 0 0 160 80 80 0 1 0 0-160z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSun = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;